import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const PaymentSuccessPage = Loadable(lazy(() => import('./components/PaymentSuccessPage')));
const PaymentPendingPage = Loadable(lazy(() => import('./components/PaymentPendingPage')));
const PaymentFailurePage = Loadable(lazy(() => import('./components/PaymentFailurePage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1). Mirrors features/shipments|quotes|drafts/routes.tsx.
 */
export const paymentsRoutes: RouteObject[] = [
  {
    path: '/payment/success',
    element: <PaymentSuccessPage />
  },
  {
    path: '/payment/pending',
    element: <PaymentPendingPage />
  },
  {
    path: '/payment/failure',
    element: <PaymentFailurePage />
  }
];
